export const CLEAR_INSURANCE_COMPANY = 'CLEAR_INSURANCE_COMPANY';

export const clearInsuranceCompany = () => ({
  type: CLEAR_INSURANCE_COMPANY
});
